import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';

import Box from '../../hoc/Box/Box';
import api from '../../axios-local-api';
import * as actions from '../../store/actions/index';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import Spinner from '../../components/UI/Spinner/Spinner';
import CustomerNetwork from '../CustomerNetwork/CustomerNetwork';
import Pod from '../Pod/Pod';
import Router from '../Router/Router';
import { FaDownload } from 'react-icons/fa';
import Collapsible from 'react-collapsible';
import classes from './Equipment.css';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';


export class Equipment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      upArrows: true,
      refreshBtn: false,

    }
    this.resetUpArrows = this.resetUpArrows.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.refreshButtonClickedOnEquipment && !this.state.upArrows) {
      this.setState({
        upArrows: true
      })
    }
  }
  componentDidMount() {
    if (this.props.rEquipment && this.props.rEquipment.claimedPods) {
      this.props.locateAllPods()
    }
  }
  componentWillUpdate() {


  }
  componentDidUpdate() {
  }
  openHandler() {
    this.setState({
      upArrows: true
    })
  }
  closeHandler() {
    this.setState({
      upArrows: false,
      refreshBtn: false
    }, () => {
      this.props.refreshButtonClicked(false);
    })
  }
  resetUpArrows() {
    this.setState({
      upArrows: false
    })
  }

  render() {
    let arrow = (
      <MdKeyboardArrowDown
        color={'gray'}
        size={'30px'} />
    )
    if (this.state.upArrows) {

      arrow = (
        <MdKeyboardArrowUp
          color={'gray'}
          size={'30px'} />

      )
    } else {

      arrow = (
        <MdKeyboardArrowDown
          color={'gray'}
          size={'30px'} />

      )
    }
    let customerNetwork;

    if (this.props.devicesByEquipment === null || this.props.devicesLoading || this.props.advancedIdsLoading) {
      customerNetwork = (<Spinner />);
    } else {
      customerNetwork = (<CustomerNetwork data={this.props.data.customerNetwork} refreshButtonClicked={() => {
        this.props.refreshButtonClicked(true);
      }} />);
    }

    return (

      <div className={[classes.BodyRow, classes.BodyRow1].join(' ')}>
        <Collapsible

          transitionTime={100}
          open={this.state.upArrows}
          onOpening={
            () => { this.openHandler() }

          }
          onClosing={
            () => { this.closeHandler() }
          }
          trigger={
            (<Box>
              <div>
                <div className={classes.BodyTitle}><b>Network Equipment</b>
                  <button className={classes.OpenCloseButton} style={{ float: 'right' }} aria-label="open arrow">
                    {arrow}
                  </button></div>
                <div className={classes.BodyInfo} >


                </div>
              </div>
            </Box>)}>
          {customerNetwork}

        </Collapsible>


      </div>
    );
  }
}


const mapStateToProps = state => {
  return {
    devicesByEquipment: state.devices.devicesByEquipment,
    devicesLoaded: state.devices.loaded,
    advancedIdsLoaded: state.devices.advancedIdsLoaded,
    equipmentLoaded: state.equipment.loaded,
    realEquipment: state.equipment.realEquipment
  }
};

const mapDispatchToProps = dispatch => {
  return {
    locateAllPods: () => { dispatch(actions.locateAllPods()) }


  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(Equipment, api));